<template>
  <div>
    <NavTop class="navbar">
      <template v-slot:headerImgRight>
        <div class="img_top_text">党委办公室</div>
      </template>
      <template v-slot:mainnavlist>
        <div class="nav" @click="navigateTo('/')">工作动态</div>
        <div class="nav" @click="navigateTo('/')">通知公告</div>
        <div class="nav" @click="navigateTo('/')">党建理论</div>
        <div class="nav" @click="navigateTo('/')">上级精神</div>
        <div class="nav" @click="navigateTo('/')">规章制度</div>
      </template>
    </NavTop>
    <!-- 工作动态 -->
    <div class="deptNews content">
      <div class="deptNews_box">
        <div class="deptNews_box_left">
          <span>工作动态</span>
          <a href="#">查看更多</a>
        </div>
        <div class="deptNews_box_right">
          <div class="deptNews_box_right_swiper">
            <el-carousel ref="carousel" trigger="click" height="360px" indicator-position="none" arrow="never"
                         autoplay :activeIndex="currentIndexBanner" @change="handleCarouselChange"
                         class="banner_carousel">
              <el-carousel-item class="lunb" v-for="(item, index) in bannerImg" :key="index">
                <img :src="item.img" alt="Carousel Image" style="width: 100%;height: 100%;">
                <div class="lunb_con">
                  <span>{{ item.txt }}</span>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="deptNews_box_right_list">
            <ul class="deptNews_box_right_list_ul">
              <li class="deptNews_box_right_list_ul_li" v-for="(item,index) in dept_list" :key="index">
                <a class="list_ul_li_a1" href="#">{{ item.title }}</a>
                <span class="list_ul_li_span">{{ item.time }}</span>
                <a class="list_ul_li_a2" href="#">
                  <img src="../../assets/images/right1.png" alt>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 通知公告 -->
    <div class="notice">
      <div class="notice_ content">
        <div class="notice_con" v-for="(item,index) in noticeData" :key="index">
          <div class="notice_con_title">
            <span>{{ item.title }}</span>
            <a href="#">查看更多</a>
          </div>
          <div class="notice_con_list">
            <ul class="notice_con_list_ul">
              <li class="notice_con_list_ul_li" v-for="(item1,index1) in item.content" :key="index1">
                <a class="notice_con_list_ul_li_a" href="#">{{ item1.txt }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import home from '../../api/home'
export default {
  data () {
    return {
      // 轮播图
      bannerImg: [
        {
          img: require('../../assets/images/new1.jpg'),
          txt: '我校张松老师受邀为廊坊开发区“送法进企业'
        },
        {
          img: require('../../assets/images/new1.jpg'),
          txt: '我校张松老师受邀为廊坊开发区“送法进企业'
        }
      ],
      // 部门新闻列表
      dept_list: [
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        },
        {
          title: '马克思主义学院举办省级思政课青教赛备赛座谈会',
          time: '2024-09-10'
        }
      ],
      // 通知公告数据
      noticeData: [
        {
          title: '通知公告',
          content: [
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            }
          ]
        }, {
          title: '党建理论',
          content: [
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            }
          ]
        }, {
          title: '上级精神',
          content: [
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            },
            {
              txt: '马克思主义学院举办党政领导干部讲授《形势与政策》课集体备课会'
            }
          ]
        }
      ],
      // 团学活动数据
      tuanxueData: [
        {
          txt: '我院成功召开2023年下半年接收预备党员转正暨接收预备党员大会',
          time: '2023-11-14'
        },
        {
          txt: '我院成功召开2023年下半年接收预备党员转正暨接收预备党员大会',
          time: '2023-11-14'
        }
      ],
      currentIndexBanner: 0 // banner轮播图
    }
  },
  methods: {
    navigateTo (path) {
      this.$router.push(path)
    },
    handleCarouselChange (index) {
      this.currentIndexBanner = index
    }
    // async ppp () {
    //   try {
    //     const res = await home.getBanner()
    //     console.log(res)
    //   } catch (e) {
    //     console.log(e)
    //   }
    // }
  }
}
</script>
<style lang="less" scoped>
ul, li {
  list-style: none;
  color: #FFFFFF;
}

a {
  text-decoration: none !important;
}

.lunb {
  overflow: hidden;

  .lunb_con {
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.4);
    transform: translateY(-45px);
    font-size: 15px;
    color: #FFFFFF;

    span {
      transform: translateX(-50px);
    }
  }
}

.banner_carousel {
  position: relative;
}

// 部门新闻
.deptNews {
  width: 100%;
  height: 450px;

  .deptNews_box {
    width: 100%;
    height: 450px;

    .deptNews_box_left {
      margin-bottom: 30px;
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 24px;
        color: #444;
        line-height: 50px;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 2px;
          background: #9e070e;
        }
      }

      a {
        text-decoration: none;
        color: #666;
        position: relative;
        line-height: 40px;
        font-size: 14px;
      }
    }

    .deptNews_box_right {
      height: 360px;
      padding: 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .deptNews_box_right_swiper {
        width: 500px;
        height: 360px;
      }

      .deptNews_box_right_list {
        width: 640px;
        height: 360px;

        .deptNews_box_right_list_ul {
          width: 100%;
          height: 100%;
          overflow: hidden;

          .deptNews_box_right_list_ul_li {
            height: 60px;
            line-height: 60px;
            border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .list_ul_li_a1 {
              display: block;
              width: 80%;
              padding-left: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-decoration: none;
              color: #444;
              font-size: 14px;
              position: relative;

              &::after {
                content: "";
                position: absolute;
                width: 5px;
                height: 5px;
                background: #8d080e;
                border-radius: 50%;
                left: 4px;
                top: 48%;
              }

              &:hover {
                color: #AB330E;
              }
            }

            .list_ul_li_a2 {
              width: 20px;
              height: 20px;
              display: inline-block;
              line-height: 20px;

              img {
                width: 100%;
              }
            }

            .list_ul_li_span {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }
    }
  }
}

// 通知公告
.notice {
  background: #f9f9f9;
  height: 465px;

  .notice_ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 430px;

    .notice_con {
      width: 375px;
      height: 350px;
      border: 1px solid #eee;
      background: #fff;

      .notice_con_title {
        padding: 0 20px;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          font-size: 24px;
          color: #444;
          line-height: 54px;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 2px;
            background: #8d080e;
            bottom: 2px;
            left: 0;
          }
        }

        a {
          color: #666666;

          &:hover {
            color: #7c2c2c;
          }
        }
      }

      .notice_con_list {
        height: 280px;
        padding: 0 20px;
        overflow: hidden;

        .notice_con_list_ul {
          width: 100%;
          height: 100%;
          padding-top: 10px;

          .notice_con_list_ul_li {
            height: 45px;
            padding-left: 20px;
            position: relative;
            border-bottom: 1px solid #eee;
            line-height: 45px;
            display: flex;
            justify-content: space-around;
            align-items: center;

            &::after {
              content: "";
              position: absolute;
              width: 5px;
              height: 5px;
              background: #8d080e;
              border-radius: 50%;
              left: 0;
              top: 50%;
            }

            .notice_con_list_ul_li_a {
              width: 100%;
              color: #333;
              display: block;
              text-decoration: none;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 15px;

              &:hover {
                color: #7c2c2c;
              }
            }
          }
        }
      }
    }
  }
}


div {
  box-sizing: border-box !important;
}

.active {
  span {
    color: #8D0835 !important;
  }
}

.content {
  width: 1200px;
  margin: 0 auto;
}

.nav:hover{
  background-color: #9E070E !important;
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    text-align: center;
  }

  .content {
    padding-left: 0;
  }
}

</style>
<script setup lang="ts">
</script>



// WEBPACK FOOTER //
// src/views/FunDept/FunDept.vue